import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  onHand: {
    defaultMessage: 'On Hand',
    id: 'kVHdJM',
    description: 'On Hand column header',
  },
  available: {
    defaultMessage: 'Available',
    id: 'dTbhdv',
    description: 'Available column header',
  },
  qty: {
    defaultMessage: 'Qty',
    id: '5kxziZ',
    description: 'Quantity column header',
  },
  half: {
    defaultMessage: 'Half',
    id: 'u3Uc/P',
    description: 'Half button text for setting quantity to half of available',
  },
  all: {
    defaultMessage: 'All',
    id: 'OIlHRB',
    description: 'All button text for setting quantity to all available',
  },
  actions: {
    defaultMessage: 'Actions',
    id: 'Tv9I/4',
    description: 'Actions column header',
  },
  clearAll: {
    defaultMessage: 'Clear',
    id: 'xEObQe',
    description: 'Clear button text',
  },
  quantityExceedsAvailable: {
    defaultMessage: 'Quantity cannot exceed Available ({available})',
    id: 'O+oXJk',
    description: 'Error message when Quantity exceeds Available value',
  },
  productsAdded: {
    defaultMessage: 'Added products ({count})',
    id: 'jd6WGo',
    description: 'Products added text',
  },
  showingProductSummary: {
    defaultMessage: 'Showing {start}-{end} of <b>{total} items</b>',
    id: 'GW8RqN',
    description: 'Showing items text',
  },
  noProductsScanned: {
    defaultMessage: 'Scan your first product to begin adding it to transfer order.',
    id: '7jEfoD',
    description: 'No products scanned text',
  },
  clearAllConfirmHeader: {
    defaultMessage: 'Clear Products',
    id: 'N0dIx4',
    description: 'Header for clear all products confirmation modal',
  },
  clearAllConfirmBody: {
    defaultMessage: 'Are you sure you want to remove all products from this Transfer Order?',
    id: 'jwY88H',
    description: 'Body text for clear all products confirmation modal',
  },
  clearAllConfirmButton: {
    defaultMessage: 'Clear all',
    id: 'lCVKja',
    description: 'Confirm button text for clear all products modal',
  },
  removeProductAriaLabel: {
    defaultMessage: 'Remove product',
    id: 'fcJM5l',
    description: 'Aria label for remove product button',
  },
  expandProductAriaLabel: {
    defaultMessage: 'Expand product rows',
    id: 'e87ebX',
    description: 'Aria label for expand product rows button',
  },
  collapseProductAriaLabel: {
    defaultMessage: 'Collapse product rows',
    id: 'lQhGrm',
    description: 'Aria label for collapse product rows button',
  },
  multipleLocations: {
    defaultMessage: '{count} locations',
    id: 'n7uymt',
    description: 'Text showing number of locations when product rows are collapsed',
  },
  multipleLocationsUnavailableTooltip: {
    defaultMessage: 'Some locations no longer have available stock',
    id: '9ZbiK2',
    description: 'Tooltip for collapsed locations when some are unavailable',
  },
  locationUnavailableText: {
    defaultMessage: 'Location unavailable',
    id: 'VT09lG',
    description: 'Short text displayed for unavailable location warning',
  },
  locationUnavailableTooltip: {
    defaultMessage: 'This location no longer has available stock',
    id: 'bLZIiv',
    description: 'Tooltip for unavailable location warning',
  },
  noInventoryInWarehouseText: {
    defaultMessage: 'No inventory',
    id: 'SNqNSw',
    description: 'Short text displayed when product has no inventory in the selected warehouse',
  },
  noInventoryInWarehouseTooltip: {
    defaultMessage: 'This product has no inventory in the selected origin warehouse',
    id: 'KEjFvP',
    description: 'Tooltip for product with no inventory in the selected warehouse',
  },
  expiredProductText: {
    defaultMessage: 'Expired',
    id: 'wKV13h',
    description: 'Short text displayed when product lot is expired and unavailable',
  },
  expiredProductTooltip: {
    defaultMessage: 'This product lot has expired and is unavailable',
    id: 'W8buOY',
    description: 'Tooltip for expired product lot warning',
  },
  unitOfMeasure: {
    id: '44otUe',
    defaultMessage: 'UoM',
    description: 'Unit of measure column header in product grid',
  },
  eaches: {
    id: 'X3qugi',
    defaultMessage: 'Eaches',
    description: 'Eaches column header showing base unit quantity',
  },
});
